<template>
  <div class="app-all">
    <!--        <van-nav-bar left-arrow :title="$route.meta.title" @click-left="$router.go(-1)"/>-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>
<style scoped>
  .app-all {
    height: 100%;
  }
</style>
<style>
  html {
    height: 100%;
  }

  body {
    height: 100%;
    margin: 0;
    font-size: 0.16rem;
    /*background-color: #eeeeee;*/
  }
  @media screen and  (min-width: 320px) {
    html{
      font-size: 58.2px;
    }
  }
  @media screen and  (min-width: 375px) {
    html{
      font-size: 68.2px;
    }
  }
  @media screen and  (min-width: 414px) {
    html{
      font-size: 75.3px;
    }
  }
  @media screen and  (min-width: 550px) {
    html{
      font-size: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue